<template> 
  <VideoPrincipal/>

  <section class="position-relative bg-white" id="funciones_principales">
    <div class="container pt-5 position-relative">
        <div class="row">
            <div class="col-md-7">
              <div class="feature-list">
                  <div class="feature-item"> 
                    <div>
                      <h6>Facturación Rápida y Sencilla</h6>
                      <p>Con nuestra facturación en la nube, podrá generar, enviar y gestionar todas sus facturas en cuestión de segundos, sin errores y cumpliendo con todas las normativas fiscales vigentes. Diga adiós a los programas complejos y a la pérdida de tiempo.</p>
                    </div>
                  </div>
                <div class="feature-item"> 
                    <div>
                      <h6>Multi Moneda</h6>
                      <p>Realiza transacciones en las monedas que tu empresa necesita: dólares, pesos, euros, bolívares y más. Con Alliance, obtén reportes personalizados en la moneda de tu elección, facilitando la gestión de tus finanzas internacionales sin complicaciones.</p>
                    </div>
                  </div>
                  <div class="feature-item"> 
                    <div>
                      <h6>Contabilidad en Tiempo Real</h6>
                      <p>Nuestro avanzado algoritmo de inteligencia contable procesa automáticamente todas tus transacciones en tiempo real, manteniendo tus registros siempre actualizados sin procesos complejos. ¡Olvídate de las tareas manuales y concéntrate en hacer crecer tu negocio!</p>
                    </div>
                  </div>
                  <div class="feature-item"> 
                    <div>
                      <h6>Control de Inventario en Vivo</h6>
                      <p>Mantén tu inventario al día y reduce riesgos de pérdida con una solución diseñada para empresas que manejan lotes y series. Con Alliance, tendrás un control completo de tu stock en tiempo real, permitiéndote tomar decisiones informadas al instante.</p>
                    </div>
                  </div>
                  <div class="feature-item"> 
                    <div>
                      <h6>Acceso Global</h6>
                      <p>Gestiona y automatiza tu negocio desde cualquier lugar, en cualquier dispositivo. Ya sea para ventas, generación de facturas o reportes, Alliance te brinda acceso total en tiempo real, dándote la flexibilidad que necesitas para operar sin fronteras.</p>
                    </div>
                  </div>
                  <div class="feature-item"> 
                    <div>
                      <h6>Control de Bancos y Caja</h6>
                      <p>Integra automáticamente todos tus cobros y pagos, y mantén tus saldos bancarios siempre al día con nuestro módulo de bancos y cajas. Alliance hace que la administración de tus cuentas sea sencilla y confiable.</p>
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-md-5">
              <img  :src="require(`@/assets/image/chicaconlaptod.png`)" class="imageList d-md-block d-none" />
              <img  :src="require(`@/assets/image/chicaconlaptodphone.png`)" class="imageList d-md-none" />
            </div>
        </div> 
    </div>
  </section>

  <section class="position-relative bg-white" id="preguntas_frecuentes">
    <div class="container py-5 position-relative">
      <div class="faq-section">
            <h2 class="faq-title">Preguntas Frecuentes</h2>
            <div class="faq-container">
            <div
                v-for="(faq, index) in faqs"
                :key="index"
                class="faq-item"
                @click="toggleAnswer(index)"
            >
                <div class="faq-question">
                <h6>{{ faq.question }}</h6>
                <span v-if="activeIndex === index" class="faq-toggle">-</span>
                <span v-else class="faq-toggle">+</span>
                </div>
                <div
                v-show="activeIndex === index"
                class="faq-answer"
                >
                <p>{{ faq.answer }}</p>
                </div>
            </div>
            </div>
        </div> 
    </div>
  </section>
</template>

<script>
    import VideoPrincipal from '../home/sections/VideoPrincipal.vue';
 
    export default {
        name: "Interes",
        components: {
            VideoPrincipal
        },
        data() {
          return {
            activeIndex: null,
            faqs: [
              {
                question: '¿Es el software costoso?',
                answer:
                  '¡No! Alliance ofrece planes accesibles desde solo $30 mensuales, brindándote una solución completa para gestionar tu negocio sin romper el presupuesto. Y lo mejor, ¡sin costos ocultos!'
              },
              {
                question: '¿Qué tan seguro es el software?',
                answer:
                  'Tu seguridad es nuestra prioridad. Implementamos medidas de seguridad avanzadas en la nube para garantizar que todos tus datos estén totalmente protegidos contra cualquier amenaza.'
              },
              {
                question: '¿Será difícil de usar?',
                answer:
                  '¡Para nada! Alliance es intuitivo y fácil de usar. Desde el primer día podrás gestionar tu negocio de forma eficiente con una interfaz clara y sencilla, diseñada para que todo sea rápido y directo.'
              },
              {
                question: '¿Qué hago si necesito ayuda?',
                answer:
                  'Nuestro equipo de soporte técnico está disponible para asistirte en cualquier momento. Estamos comprometidos a proporcionarte la mejor experiencia posible, resolviendo cualquier duda o problema rápidamente.'
              },
              {
                question: '¿Puedo acceder al software desde cualquier lugar?',
                answer:
                  'Sí, Alliance es un software 100% en la nube, lo que significa que puedes acceder a él desde cualquier dispositivo con conexión a internet, sin instalaciones complicadas ni limitaciones.'
              },
              {
                question: '¿Qué sucede si quiero cancelar mi suscripción?',
                answer:
                  'No hay problema. Puedes cancelar tu suscripción en cualquier momento, sin complicaciones. Queremos que te sientas seguro con tu decisión, y nos aseguraremos de que el proceso sea fácil y sin sorpresas.'
              }
            ]
            };
          },
        methods: {
          toggleAnswer(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
          }
        }
    }

</script>

<style scoped lang="scss">

//   @import "../../scss/theme";

  .fontSize45 {
    font-size: 47px
  }

  .barra {
    background-color: theme-color("dark");
    height: 125px;  
  }
  
  @media (max-width: 1200px) { 
        .barra {
            background-color: theme-color("dark");
            height: 80px;  
        }
  }

    .faq-section {
        margin: 50px auto;
        max-width: 800px;
        padding: 0 20px;

      .faq-title {
        text-align: center;
        font-size: 2rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 30px;
      }

      .faq-container {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .faq-item {
          background-color: #f9f9f9;
          border-radius: 8px;
          padding: 20px;
          cursor: pointer;
          transition: background-color 0.3s ease;

          &:hover {
            background-color: #f1f1f1;
          }

          .faq-question {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 1.1rem;
            font-weight: 600;
            color: #333;
          }

          .faq-toggle {
            font-size: 1.5rem;
            color: #333;
            transition: transform 0.3s ease;
          }

          .faq-answer {
            padding: 10px 0;
            font-size: 1rem;
            color: #666;
            line-height: 1.5;
          }
        }
      }
    }


    .feature-list {
      width: 100%;
      max-width: 600px;
      padding: 0;
      margin: 0;
    }
    .feature-item {
      display: flex;
      align-items: flex-start;
      border-left: 4px solid #007bff;
      padding: 10px;
      margin-bottom: 10px;
      background-color: #fff;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      border-radius: 5px;
    }
    .feature-item h6 {
      margin: 0 0 2px 0;
      color: #007bff;
    }
    .feature-item p {
      margin: 0;
      line-height: 1.5;
      font-size: 12px;
      color: #666;
    }
    
    .imageList {
      width: 100%;
      height: 100%;
      object-position: center;
      object-fit: contain;
    }

</style>